import * as React from "react";

export const DrawerContext = React.createContext({
  isDrawerOpen: false,
  setIsDrawerOpen: (_val) => {},
});

export default function DrawerContextProvider({ children }) {
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

  const ctx = {
    isDrawerOpen,
    setIsDrawerOpen,
  };

  return <DrawerContext.Provider value={ctx}> {children}</DrawerContext.Provider>;
}
